/**
 * phoenix-pdp-configurator.js — Phoenix Putter Co, putter PDP v2
 *
 * Drives sections/phoenix-pdp-configurator.liquid. Emits the SAME line-item properties as
 * the Customization Studio (assets/customizer.js) so the "No Customization" Shopify Flow,
 * ShipStation item options and the shop's production sheet are unchanged:
 *   Customization        'Customized — see details below' | 'No Customization Needed'
 *   Length               e.g. 34"
 *   Handedness           'Right Hand' | 'Left Hand'
 *   Customized Zones     'face, back' | 'None'
 *   <Zone> Design        'Text: "D. SMITH" (Bebas Neue)' and/or 'Graphic: 1 image uploaded'
 *   Font Selection       font(s) used (comma-joined if they differ)
 *   Custom Font Request  only when 'Other' is chosen
 *   <Zone> Graphic N     Cloudinary secure_url, N counts across all zones
 * Grip is a second cart line with { _bundled_for: <product title> } — same as the Studio.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-ppdp-cfg]');
  if (!root) return;

  var cfg = {
    variantId: root.dataset.variantId,
    basePrice: parseInt(root.dataset.basePrice || '0', 10), // cents
    currency: root.dataset.currency || '$',
    productTitle: root.dataset.productTitle || 'Custom Putter',
    cloud: root.dataset.cloudName,
    preset: root.dataset.uploadPreset,
    maxChars: parseInt(root.dataset.maxChars || '30', 10),
    redirect: root.dataset.redirect || 'cart'
  };

  var ZONES = ['face', 'back', 'sole'];
  var ZONE_LABEL = { face: 'Face', back: 'Back', sole: 'Sole' }; // Studio uses these exact words in property keys

  var state = {
    handedness: '',
    length: '',
    gripVariant: '',
    gripPrice: 0,
    customization: null, // 'yes' | 'no'
    activeZone: 'face',
    zones: {}
  };
  ZONES.forEach(function (z) {
    state.zones[z] = { mode: 'text', text: '', font: '', customFont: '', graphicUrl: '' };
  });

  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };

  var els = {
    hands: $$('[data-ppdp-hand]'),
    length: $('[data-ppdp-length]'),
    grip: $('[data-ppdp-grip]'),
    choices: $$('[data-ppdp-choice]'),
    tabs: $$('[data-ppdp-tab]'),
    panels: $$('[data-ppdp-panel]'),
    error: $('[data-ppdp-error]'),
    atc: $('[data-ppdp-atc]'),
    atcLabel: $('[data-ppdp-atc-label]'),
    price: $('[data-ppdp-price]')
  };

  /* ---------- helpers ---------- */
  function money(cents) {
    var v = (cents / 100);
    var s = v % 1 === 0 ? v.toFixed(0) : v.toFixed(2);
    return cfg.currency + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function showError(msg, fieldKey) {
    if (els.error) { els.error.textContent = msg; els.error.hidden = false; }
    $$('[data-ppdp-field]').forEach(function (f) { f.classList.remove('ppdp-field--invalid'); });
    if (fieldKey) {
      var f = $('[data-ppdp-field="' + fieldKey + '"]');
      if (f) { f.classList.add('ppdp-field--invalid'); f.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }
  }
  function clearError() {
    if (els.error) { els.error.hidden = true; els.error.textContent = ''; }
    $$('[data-ppdp-field]').forEach(function (f) { f.classList.remove('ppdp-field--invalid'); });
  }
  function zoneHasContent(z) {
    var s = state.zones[z];
    return (s.mode === 'text' && s.text.trim().length > 0) || (s.mode === 'graphic' && !!s.graphicUrl);
  }
  function updatePrice() {
    var total = cfg.basePrice + (state.gripPrice || 0);
    if (els.price) els.price.textContent = money(total);
  }
  function updateTabStatus(z) {
    var tab = $('[data-ppdp-tab="' + z + '"]');
    if (!tab) return;
    var small = tab.querySelector('[data-ppdp-tab-status]');
    var s = state.zones[z];
    var filled = zoneHasContent(z);
    tab.classList.toggle('ppdp-tab--filled', filled);
    if (!small) return;
    if (!filled) { small.textContent = 'Blank'; return; }
    small.textContent = s.mode === 'graphic' ? 'Logo' : s.text.trim();
  }

  /* ---------- fit ---------- */
  els.hands.forEach(function (b) {
    b.addEventListener('click', function () {
      state.handedness = b.dataset.ppdpHand;
      els.hands.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      clearError();
    });
  });
  if (els.length) {
    els.length.addEventListener('change', function () { state.length = els.length.value; clearError(); });
  }
  if (els.grip) {
    els.grip.addEventListener('change', function () {
      var opt = els.grip.options[els.grip.selectedIndex];
      state.gripVariant = els.grip.value;
      state.gripPrice = opt ? parseInt(opt.dataset.price || '0', 10) : 0;
      updatePrice();
    });
  }

  /* ---------- clean / engrave ---------- */
  els.choices.forEach(function (b) {
    b.addEventListener('click', function () {
      state.customization = b.dataset.ppdpChoice;
      els.choices.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      root.classList.toggle('ppdp-cfg--clean', state.customization === 'no');
      clearError();
    });
  });

  /* ---------- tabs ---------- */
  function showZone(z) {
    state.activeZone = z;
    els.tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t.dataset.ppdpTab === z)); });
    els.panels.forEach(function (p) { p.hidden = p.dataset.ppdpPanel !== z; });
  }
  els.tabs.forEach(function (t) { t.addEventListener('click', function () { showZone(t.dataset.ppdpTab); }); });
  $$('[data-ppdp-next]').forEach(function (b) {
    b.addEventListener('click', function () {
      showZone(b.dataset.ppdpNext);
      // Opening a zone implies the customer wants engraving
      if (!state.customization) { var yes = $('[data-ppdp-choice="yes"]'); if (yes) yes.click(); }
    });
  });

  /* ---------- per-zone panels ---------- */
  els.panels.forEach(function (panel) {
    var z = panel.dataset.ppdpPanel;
    var s = state.zones[z];
    var previewText = $('[data-ppdp-preview-text]', panel);
    var previewImg = $('[data-ppdp-preview-img]', panel);
    var count = $('[data-ppdp-count]', panel);
    var textInput = $('[data-ppdp-text]', panel);
    var fontSelect = $('[data-ppdp-font]', panel);
    var fontTiles = $('[data-ppdp-fonts]', panel);
    var customFont = $('[data-ppdp-custom-font]', panel);
    var modeBtns = $$('[data-ppdp-mode]', panel);
    var modePanels = $$('[data-ppdp-mode-panel]', panel);
    var upload = $('[data-ppdp-upload]', panel);
    var file = $('[data-ppdp-file]', panel);
    var uploaded = $('[data-ppdp-uploaded]', panel);
    var remove = $('[data-ppdp-remove]', panel);

    // Build font tiles from the shared <select> (single source of truth), first 4 + "More"
    if (fontSelect && fontTiles) {
      var opts = Array.prototype.slice.call(fontSelect.options).filter(function (o) { return o.value && o.value !== 'Other'; });
      s.font = fontSelect.value || (opts[0] && opts[0].value) || 'Outfit';
      var shown = opts.slice(0, 3);
      shown.forEach(function (o) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'ppdp-font';
        b.textContent = o.value;
        b.style.fontFamily = '"' + o.value + '", sans-serif';
        b.dataset.font = o.value;
        b.setAttribute('aria-pressed', String(o.value === s.font));
        b.addEventListener('click', function () { setFont(o.value); });
        fontTiles.appendChild(b);
      });
      var more = document.createElement('button');
      more.type = 'button'; more.className = 'ppdp-font'; more.textContent = 'More…';
      more.style.color = '#6B7075'; more.style.fontSize = '15px';
      more.addEventListener('click', function () { fontSelect.hidden = false; fontSelect.focus(); });
      fontTiles.appendChild(more);
      fontSelect.hidden = true;

      fontSelect.addEventListener('change', function () { setFont(fontSelect.value, true); });
      if (customFont) customFont.addEventListener('input', function () { s.customFont = customFont.value; render(); });
    }

    function setFont(name, fromSelect) {
      s.font = name;
      if (fontSelect && fontSelect.value !== name) fontSelect.value = name;
      $$('.ppdp-font[data-font]', fontTiles).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.font === name)); });
      var isOther = name === 'Other';
      if (customFont) customFont.hidden = !isOther;
      if (!fromSelect && fontSelect) fontSelect.hidden = true;
      render();
    }

    function render() {
      if (previewText) {
        var isText = s.mode === 'text';
        previewText.style.display = isText ? '' : 'none';
        previewText.textContent = isText ? s.text : '';
        var fam = s.font === 'Other' ? (s.customFont || 'Outfit') : (s.font || 'Outfit');
        previewText.style.fontFamily = '"' + fam + '", sans-serif';
      }
      if (previewImg) {
        var hasImg = s.mode === 'graphic' && s.graphicUrl;
        previewImg.style.display = hasImg ? 'block' : 'none';
        if (hasImg) previewImg.src = s.graphicUrl;
      }
      if (count) count.textContent = s.mode === 'text' && s.text.length ? s.text.length + ' / ' + cfg.maxChars : '';
      updateTabStatus(z);
    }

    if (textInput) {
      textInput.addEventListener('input', function () {
        s.text = textInput.value;
        if (s.text.trim() && !state.customization) { var yes = $('[data-ppdp-choice="yes"]'); if (yes) yes.click(); }
        render();
      });
    }

    modeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        s.mode = b.dataset.ppdpMode;
        modeBtns.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        modePanels.forEach(function (p) { p.hidden = p.dataset.ppdpModePanel !== s.mode; });
        render();
      });
    });

    function setUploaded(url) {
      s.graphicUrl = url || '';
      if (uploaded) uploaded.style.display = url ? 'flex' : 'none';
      if (upload) upload.style.display = url ? 'none' : '';
      if (url && !state.customization) { var yes = $('[data-ppdp-choice="yes"]'); if (yes) yes.click(); }
      render();
    }

    if (file) {
      file.addEventListener('change', function () {
        var f = file.files && file.files[0];
        if (!f) return;
        if (f.size > 5 * 1024 * 1024) { showError('That file is over 5 MB — please use a smaller image.'); file.value = ''; return; }
        clearError();
        if (upload) upload.classList.add('ppdp-upload--busy');
        uploadToCloudinary(f).then(function (url) {
          setUploaded(url);
        }).catch(function (err) {
          console.error('[ppdp] upload failed', err);
          showError('Logo upload failed. Please try again, or add to cart with text and email us the file.');
        }).then(function () {
          if (upload) upload.classList.remove('ppdp-upload--busy');
          file.value = '';
        });
      });
    }
    if (remove) remove.addEventListener('click', function () { setUploaded(''); });

    render();
  });

  function uploadToCloudinary(f) {
    var fd = new FormData();
    fd.append('file', f);
    fd.append('upload_preset', cfg.preset);
    fd.append('folder', 'phoenix-orders');
    return fetch('https://api.cloudinary.com/v1_1/' + cfg.cloud + '/image/upload', { method: 'POST', body: fd })
      .then(function (r) { if (!r.ok) throw new Error('upload ' + r.status); return r.json(); })
      .then(function (d) { return d.secure_url; });
  }

  /* ---------- add to cart ---------- */
  function buildProperties() {
    var filled = ZONES.filter(zoneHasContent);
    var props = {
      'Customization': state.customization === 'no' ? 'No Customization Needed' : 'Customized — see details below',
      'Length': state.length,
      'Handedness': state.handedness,
      'Customized Zones': state.customization === 'no' ? 'None' : (filled.join(', ') || 'None')
    };
    if (state.customization === 'no') return props;

    var fonts = [];
    var customFonts = [];
    var fileCount = 1;
    filled.forEach(function (z) {
      var s = state.zones[z];
      var label = ZONE_LABEL[z];
      var parts = [];
      if (s.mode === 'text' && s.text.trim()) {
        var fam = s.font === 'Other' ? (s.customFont || 'Custom Request') : s.font;
        parts.push('Text: "' + s.text.trim() + '" (' + fam + ')');
        if (fonts.indexOf(s.font) === -1) fonts.push(s.font);
        if (s.font === 'Other' && s.customFont && customFonts.indexOf(s.customFont) === -1) customFonts.push(s.customFont);
      }
      if (s.mode === 'graphic' && s.graphicUrl) {
        parts.push('Graphic: 1 image uploaded');
        props[label + ' Graphic ' + fileCount] = s.graphicUrl;
        fileCount++;
      }
      props[label + ' Design'] = parts.join(', ');
    });
    if (fonts.length) props['Font Selection'] = fonts.join(', ');
    if (fonts.indexOf('Other') !== -1) props['Custom Font Request'] = customFonts.join(', ') || 'Custom Request';
    return props;
  }

  function validate() {
    if (!state.handedness) { showError('Pick right or left hand to continue.', 'handedness'); return false; }
    if (!state.length) { showError('Choose a shaft length to continue.', 'length'); return false; }
    if (!state.customization) { showError('Tell us whether to engrave it or leave it clean.', 'customization'); return false; }
    if (state.customization === 'yes' && !ZONES.some(zoneHasContent)) {
      showError('Add text or a logo to at least one zone — or choose "Leave it clean".', 'customization');
      return false;
    }
    return true;
  }

  if (els.atc) {
    els.atc.addEventListener('click', function () {
      if (!validate()) return;
      clearError();
      els.atc.disabled = true;
      var og = els.atcLabel ? els.atcLabel.textContent : '';
      if (els.atcLabel) els.atcLabel.textContent = 'Adding…';

      var items = [{ id: parseInt(cfg.variantId, 10), quantity: 1, properties: buildProperties() }];
      if (state.gripVariant && !isNaN(parseInt(state.gripVariant, 10))) {
        items.push({ id: parseInt(state.gripVariant, 10), quantity: 1, properties: { '_bundled_for': cfg.productTitle } });
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Add to cart failed'); });
        return r.json();
      }).then(function () {
        if (els.atcLabel) els.atcLabel.textContent = '✓ Added to cart';
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (cfg.redirect === 'cart') {
          setTimeout(function () { window.location.href = '/cart'; }, 600);
        } else {
          setTimeout(function () { els.atc.disabled = false; if (els.atcLabel) els.atcLabel.textContent = og; }, 2500);
        }
      }).catch(function (err) {
        console.error('[ppdp] add to cart', err);
        showError(err.message || 'Something went wrong adding this to your cart. Please try again.');
        els.atc.disabled = false;
        if (els.atcLabel) els.atcLabel.textContent = og;
      });
    });
  }

  /* ---------- in-page jumps (IMPACT intercepts a[href^="#"], so these are buttons) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ppdp-scroll]');
    if (!b) return;
    var target = document.querySelector(b.dataset.ppdpScroll);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  updatePrice();
})();
